import { createFileRoute } from "@tanstack/react-router";

import { locationSearchParamsSchema } from "@/domain/location";
import { LocationsScreen } from "@/interactors/LocationsScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/locations/")({
  component: LocationsScreen,
  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "read",
      subject: "locations",
    }),
  validateSearch: locationSearchParamsSchema,
  head: () => headWithCustomTitle("main:students.title"),
});
